import api from "./api";
import {iniciarRequisicao, logout} from "../helpers/index"
import {STATUS_HTTP} from "@/api/statusHTTP";

export const pedidoEmTransitoDesconsiderado = async (params) => {
  const url = '/produtos/pedidos-em-transito/desconsiderados';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

class Requisicao
{
  async getRequisicaoPendenteProduto(idGrupo, idProduto, params) {
    return await api.get(
      `/requisicao/pendente/grupos/${idGrupo}/produtos/${idProduto}`,
      { params, headers: iniciarRequisicao() }
    );
  }

  async getRequisicaoDepartamento(params) {
    return await api.get(
      `/requisicao/pendente/grupos/departamento`,
      { params, headers: iniciarRequisicao() }
    );
  }

  async buscarRequisicoesCategoriaMateriaPrima(params) {
    return await api.get(
      `/requisicao/pendente/grupos/categorias/materia-prima`,
      { params, headers: iniciarRequisicao() }
    );
  }

  async buscarUltimasComprasDepartamento(params) {
    return await api.get(
      `/requisicao/departamento`,
      { params, headers: iniciarRequisicao() }
    );
  }

  async buscarUltimasComprasCategoriaMateriaPrima(params) {
    return await api.get(
      `/requisicao/categorias/materia-prima`,
      { params, headers: iniciarRequisicao() }
    );
  }
}

export default new Requisicao();
